module.exports = require('./squaredDistance')
